import { AxiosResponse } from "axios";
import hireu from "../api/request";
import { getClientIpAddress } from "./GetIpAddress";
const url =  "https://zm68s75mzl.execute-api.us-east-1.amazonaws.com/prod/api/send";

export const trackMixpanelEvent = async (
  eventName: string,
  email: string,
  payload?: any,
): Promise<AxiosResponse<any>> => {
  return await hireu.request({
    url: url,
    method: "POST",
    data: {
      method: "track",
      eventName: eventName,
      email: email,
      payload: {
        ...payload,
      },
    },
  });
};

export const setMixpanelUser = async (email: string, user: any): Promise<AxiosResponse<any>> => {
  const ip = await getClientIpAddress();

  return await hireu.request({
    url: url,
    method: "POST",
    data: {
      method: "set",
      email: email,
      ip: ip,
      payload: {
        ...user,
        $email:email
      },
    },
  });
};
